//
//
//
//
//
//
//
//
//
//
//

import CompilationItem from "~/components/compilations/CompilationItem"
export default {
  components: {
    CompilationItem
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    view: {
      type: String,
      required: false,
      default: 'v'
    },
    sectionId: {
      type: Number,
      required: true
    },
    sectionCode: {
      type: String,
      required: true
    },

  }

}
